import { BaseModel } from './BaseModel';

export class PersonalAccessToken extends BaseModel {
    public name = '';
    public token = '';
    public lastUsedAt?: number;
    public createdAt = -1;

    get user() {
        return this.getRelationship('user');
    }
}
